import kebabCase from 'lodash.kebabcase'
import { useTranslation } from 'react-i18next'

export interface ResourceLink {
  text: string
  url: string
  openInNewWindow?: boolean
}

export interface ResourceLinkList {
  heading: string
  links: ResourceLink[]
}

export interface RelatedResourcesProps {
  heading: string
  lists: ResourceLinkList[]
}

// Returns the number of columns to span to equally accommodate a given number of columns.
// The returned span will be an integer factor of the total number of columns.
export function getColumnSpan (numColumns: number): number {
  const maxColumns = 12
  if (numColumns === 0) {
    return maxColumns
  }
  if (numColumns >= maxColumns) {
    return 1
  }
  return Math.floor(maxColumns / numColumns)
}

export function RelatedResources ({ heading, lists }: RelatedResourcesProps) {
  const { t } = useTranslation('common')
  const columnSpan = getColumnSpan(lists.length)
  return (
    <section className='ds-l-container ds-u-visibility--hidden-print'>
      <div className='ds-l-row'>
        <div className='ds-l-col--12'>
          <h2 className='ds-text-heading--2xl ds-u-margin-top--4 ds-u-padding-top--6 ds-u-border-top--1'>{heading}</h2>
        </div>
      </div>
      <div className='ds-l-row'>
        {lists.map(({ heading, links }) => {
          const id = `related-resources-${kebabCase(heading)}`
          return (
            <div key={id} className={`ds-u-margin-top--3 ds-l-sm-col--${columnSpan}`}>
              <h3 id={id} className='ds-text-heading--xl'>{heading}</h3>
              <ul className='ds-c-list ds-c-list--bare' aria-labelledby={id}>
                {links.map(({ text, url, openInNewWindow }) => (
                   <li key={kebabCase(text)}>
                     <a href={url} rel='noreferrer' {...openInNewWindow && { target: '_blank' }}>
                       {text}
                       {openInNewWindow && <span className='ds-u-visibility--screen-reader'>{t('opensInNewWindow')}</span>}
                     </a>
                   </li>
                ))}
              </ul>
            </div>
          )
        })}
      </div>
    </section>
  )
}
